<div class="roles">
  @if (isUserInvitation) {
    <app-tag [tag]="invitationTag"/>
  }

  @for (role of roles; track role.tagId) {
    <app-tag [tag]="role" (clickTag)="handleRoleClick(role)"/>
  }
</div>
